import request from '../../../api/api';

function getDateString(date) {
    const dt = (('0' + date.getDate()).slice(-2));
    const month = (('0' + (date.getMonth() + 1)).slice(-2));

    return dt + '.' + month + '.' + date.getFullYear();
}

export default function SaveOrder(saleTimes, menus, id, type, date, description = '') {
    return (dispatch) => {
        const orderBody = saleTimes.map((time) => {
            const orderLocation = time.orderLocation;
            const saleId = time.saleTimeId;
            const orderMenu = menus[saleId][orderLocation];
            return {
                saleTimeId: saleId,
                orderLocation: orderLocation,
                locations: [{
                    locationId: orderLocation,
                    orderDescription: description,
                    wares: orderMenu.wares.reduce((res, ware) => {
                        if (ware.waresQuantity) {
                            res.push({
                                "priceWaresId": ware.priceWaresId,
                                "waresQuantity": ware.waresQuantity,
                                "orderWaresId": ware.orderWaresId,
                            });
                        }

                        return res;
                    }, [])
                }]
            }
        });
        //.filter((item) => item.locations[0].wares.length > 0);

        return request(
            '/v1/orders/food/save_order',
            'object_id=' + id +
            '&object_type=' + type +
            '&order_date=' + getDateString(date) +
            '&order_body=' + encodeURI(JSON.stringify({saleTimes: orderBody, returnCode: 1})),
            'post'
        ).then((data) => {
            dispatch({
                type: 'jbs',
                meta: {dialog: {changing: false}}
            });

            return data;
        });
    }
};



/** WEBPACK FOOTER **
 ** ./src/modules/food/actions/SaveOrder.js
 **/